import Settings from "@/features/users/settings";

const UserSettings = () => {
  return <Settings />;
};

export default UserSettings;
